export type SubmitOutcome =
  | { kind: "started"; calibrationMeasurementSetId?: string }
  | { kind: "yieldUpdated" }
  | { kind: "inProgress"; calibrationMeasurementSetId?: string }
  | { kind: "failed"; errorCode: string | undefined }
  | { kind: "notStarted" }
  | { kind: "error" };

type SubmitResponseBody = {
  code?: string;
  calibration_measurement_set_id?: string;
  detail?: {
    calibration_measurement_set_id?: string;
    error?: { code?: string };
  };
};

async function readBody(response: Response): Promise<SubmitResponseBody> {
  try {
    return await response.json();
  } catch {
    return {};
  }
}

export async function readSubmitOutcome(
  response: Response | null,
): Promise<SubmitOutcome> {
  if (!response) return { kind: "error" };
  if (response.status === 200) return { kind: "yieldUpdated" };

  const body = await readBody(response);

  if (response.status === 202) {
    return {
      kind: "started",
      calibrationMeasurementSetId: body.calibration_measurement_set_id,
    };
  }
  if (response.status === 409 && body.code === "CalibrationInProgress") {
    return {
      kind: "inProgress",
      calibrationMeasurementSetId: body.detail?.calibration_measurement_set_id,
    };
  }
  if (response.status === 422 && body.code === "CalibrationFailed") {
    return { kind: "failed", errorCode: body.detail?.error?.code };
  }
  if (response.status === 503 && body.code === "CalibrationNotStarted") {
    return { kind: "notStarted" };
  }
  return { kind: "error" };
}
